import Vue from 'vue'
Vue.directive("load_more", {
    componentUpdated: function(el, binding){
        window.addEventListener('scroll', ()=> {
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            if(scrollTop + window.innerHeight >= el.clientHeight) {
                let fnc = binding.value;
                fnc();
            }
        })
    }
})
